<template>
    <div class="company__header--list">
      <CompanyCard
        v-for="(company, index) in companies"
        :key="index"
        :company="company"
        :selectedCompany="currentCompany"
        @setSelectedCompany="setSelectedCompany"
        @onClick="(company) => handleRedirect(company)"
      />
  </div>
</template>

<script>
import config from "../config";
import CompanyCard from "./CompanyCard.vue";
import defaultImage from "../../public/img/icons/unknown-icon.jpg";

export default {
  data() {
    return {
      imgPath: config.URL_IMAGE,
      isLoading: false,
      fallbackImage: defaultImage,
    };
  },
  components: {
    CompanyCard,
  },
  props: ["companies", "selectedCompany"],
  emits: ["onRedirect", 'selectedCompany'],
  methods: {
    setSelectedCompany(company) {
    this.$emit("selectedCompany", company);

    },
    handleRedirect(company) {
      this.$emit("onRedirect", company);
    },
    handleImgError(event) {
      event.target.src = this.fallbackImage;
    },
  },
  computed: {
    companiesList() {
      return this.companies;
    },
    currentCompany() {
      return this.selectedCompany;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.container__display-content {
  height: 100%;
  display: flex;
  width: 65%;
  min-width: 65%;
  max-width: 65%;
  flex-direction: column;
  justify-content: start;
  position: relative;
}

.company__header {
  height: 65%;
  width: 100%;
  position: relative;
}

.img__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(35, 10, 65, 0.699); */
  opacity: 0.7;
}

.company__header--img {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
}

.company__header--list {
  /* position: absolute; */
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow-x: auto;
  z-index: 1000000;
  height: 100%;
  align-items: center;
}

.selected__logo {
  position: absolute;
  top: 45%;
  left: 45%;
  z-index: 1000;
}

.selected__logo--img {
  width: 100px;
  height: 100px;
  position: absolute;
}

.company__header--list::-webkit-scrollbar {
  height: 8px; /* altura da barra horizontal */
}

.company__header--list::-webkit-scrollbar-track {
  background: transparent;
}

.company__header--list::-webkit-scrollbar-thumb {
  background-color: #d7dae2;
  border-radius: 8px;
}

.company__header--list::-webkit-scrollbar-thumb:hover {
  background-color: #bbbec4;
}
</style>
